module.exports = __webpack_public_path__ + "static/media/edit-notes.0e310a58.svg";